module.exports = __webpack_public_path__ + "img/3.b99793e9.jpg";